<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>Создание промокода</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <promocode-form
          :errors="errors"
          @onSubmit="submit"
        />
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbarSuccess"
      :timeout="timeout"
      color="success"
    >
      Сохранено

      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          @click="snackbarSuccess = false"
          color="red"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="snackbarError"
      :timeout="timeout"
      color="error"
    >
      {{ this.errors }}

      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          @click="snackbarError = false"
          color="red"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import PromocodeForm from "../../../components/promocodes/PromocodeForm";
import {Promocode} from "../../../models/promocode";

export default {
  name: 'Create',
  components: { PromocodeForm },
  data: () => ({
    errors: {},
    snackbarSuccess: false,
    snackbarError: false,
    timeout: 2000,
  }),
  methods: {
    async submit({ form }) {
      try {
        this.errors = {};
        const promocode = await Promocode.$query().store(form);
        await this.$router.push({ name: 'promocodes-edit', params: { id: promocode.$attributes.id } });
        this.snackbarSuccess = true;
      } catch (e) {
        if (e.response?.data) {
          this.errors = e.response.data.errors
          this.snackbarError = true;
        }
        throw e;
      }
    },
  },
};
</script>
